import * as yup from 'yup';

// start with this schema as a default for validation
export const emailSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required('Email is required')
    .email('Invalid email address'),
});
